module.exports = __webpack_public_path__ + "static/media/game-logs-icon.82ce5641.svg";